import { render, staticRenderFns } from "./SetupPasswordPage.vue?vue&type=template&id=2b8610f8&"
import script from "./SetupPasswordPage.vue?vue&type=script&lang=js&"
export * from "./SetupPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports